<template>
  <main>
    <div id="features" class="top-title">
      <img src="@/assets/image/features.png">
    </div>
    <div id="products" class="products">
      <section>
        <div class="section-content odd">
          <div class="content-left">
            <img
              src="@/assets/image/img_screenshot_rich.png"
              alt="Embark on a Journey of Discovery"
              class="screenshot"
            >
          </div>
          <div class="content-right">
            <div class="content-title_box">
              <gradient-text
                value="Rich library"
                subtitle="Explore a rich and diverse collection of short dramas and
              mini-series, each with a unique plot and characters."
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="section-content odd">
          <div id="product2-left" class="product-right">
            <gradient-text
              value="Quick Watch"
              subtitle="Enjoy episodes that are just the right length for your busy schedule, perfect for a short break or your daily commute."
            />
          </div>
          <div id="product2-right" class="product-left">
            <img
              src="@/assets/image/img_screenshot_recommende.png"
              alt="Curated Dramas in HD"
              class="screenshot"
            >
          </div>
        </div>
      </section>
      <section>
        <div class="section-content odd">
          <div class="content-left">
            <img
              src="@/assets/image/img_screenshot_updating.png"
              alt="Embark on a Journey of Discovery"
              class="screenshot"
            >
          </div>
          <div class="content-right">
            <div class="content-title_box">
              <gradient-text
                value="Personalized recommendations"
                subtitle="Our advanced algorithm learns your preferences and recommends tailored content for you."
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="section-content odd">
          <div id="product2-left" class="product-right">
            <gradient-text
              value="User-friendly interface"
              subtitle="Easily navigate our elegant design to ensure a simple and enjoyable browsing experience."
            />
          </div>
          <div id="product2-right" class="product-left">
            <img
              src="@/assets/image/img_screenshot_interface.png"
              alt="Curated Dramas in HD"
              class="screenshot"
            >
          </div>
        </div>
      </section>
    </div>
    <div id="download" class="top-title">
      <img src="@/assets/image/download.png">
    </div>
    <div class="download">
      <section>
        <div class="section-content">
          <div class="download-left">
            <h3>AntTV</h3>
            <p>
              Download AntTV now to start your short drama watching journey and
              experience engaging stories and great episodes!
            </p>
            <download-buttom style="margin-top: 40px" />
          </div>
          <div class="download-right">
            <qr-code :value="$store.state.user.downloadUrl" />
          </div>
        </div>
      </section>
    </div>
    <div id="contact" class="top-title">
      <img src="@/assets/image/contact.png">
    </div>
    <div class="contact">
      <section>
        <div class="section-content contact-container">
          <div>
            <contact-section
              :icon="company"
              name="Company Name"
              note="Shenyang Xicheng Network Technology Co., Ltd"
              note-zh="沈阳浠程网络科技有限公司"
            />
          </div>
          <div class="address">
            <contact-section
              :icon="address"
              name="Address"
              note="No. 22, Puchang Road, Shenbei New District, Shenyang City, Liaoning Province (Gate 4081) H49"
              note-zh="地址：辽宁省沈阳市沈北新区蒲昌路22号（4081门）H49"
            />
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import GradientText from '@/components/gradientText.vue'
import QrCode from '@/components/qrcode.vue'
import ContactSection from '@/components/contact.vue'
import DownloadButtom from '@/components/downloadButtom.vue'
import company from '@/assets/image/company.png'
import address from '@/assets/image/address.png'
export default {
  name: 'MainCom',
  components: {
    GradientText,
    QrCode,
    ContactSection,
    DownloadButtom,
  },
  data() {
    return {
      company,
      address,
    }
  },
}
</script>

<style lang="scss" scoped>
main .top-title {
  background-color: #000000;
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
  img {
    width: 40%;
  }
}
main section {
  width: 100%;
  background-color: #000000;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: Inter;
}
section .section-content {
  display: flex;
  max-width: 900px;
  margin: 0 auto;

  align-items: center;
  flex-direction: row;
  height: 100%;
  position: relative;
  @media screen and (max-width: 768px) {
    padding: 0 48px;
  }
  .content-right {
    margin-left: 50px;
  }
  .product-right {
    margin-right: 50px;
  }
  .screenshot {
    height: 548px;
  }
}
section .odd {
  padding-bottom: 200px;
}
.download {
  .section-content {
    max-width: 900px;
    display: flex;
  }
  .download-left {
    margin-right: 100px;
    h3 {
      background: linear-gradient(to bottom, #9334ff, #ab21cd);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 60px;
    }
    p {
      font-weight: 400;
      font-size: 24px;
      color: #fff;
      margin-top: 20px;
    }
  }
}
.contact-container {
  flex-direction: column !important;
  align-items: flex-start !important;
  padding-bottom: 166px;
  .address {
    margin-top: 100px;
  }
}
</style>
